<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px;">
        <van-field v-model="inputForm.inspectDate" label="考察时间" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.inspectPersonName" label="考察负责人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.inspectCompanion" label="考察同行人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractorName" label="承包商名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractorTypeLabel" label="承包商类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractorCategoryLabel" label="承包商分类" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractorCategory === '0'" v-model="inputForm.materCategoryNames" label="经营种类" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractorCategory === '1'" v-model="inputForm.transportScopeLabel" label="运输范围" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.vehicleTypeNames" label="车型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.linkPerson" label="联系人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.linkPhone" label="联系方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </div>
      <van-collapse-item title="业务单位位置信息" name="1">
        <van-field v-model="inputForm.nation" label="国家" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-if="isCountryChina" v-model="inputForm.province" label="省" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-if="isCountryChina" v-model="inputForm.city" label="市" label-width="130px" readonly input-align="left" :border="false"
                   autosize rows="1" type="textarea"/>
        <van-field v-if="!isCountryChina" v-model="inputForm.city" label="城市" label-width="130px" readonly input-align="left" :border="false"
                   autosize rows="1" type="textarea"/>
        <van-field v-if="isCountryChina" v-model="inputForm.area" label="县（区）" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.address" label="详细地址" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remark" label="备注" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
          <p style="color: #AAA">附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../api/flowable/TaskService";
import ProcessService from "../../../../api/flowable/ProcessService";
import QueryInfoService from '@/api/system/queryInfoService'
export default {
  name: "ItsBaseContractorInspect",
  data(){
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_base_contractor_inspect',
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'linkPerson', label: '销售员', width: '120px'},
        {key: 'linkPhone', label: '联系方式', width: '120px'},
        {key: 'remark', label: '备注', width: '150px'},
      ]
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  computed: {
    // 选择的国家是否为中国
    isCountryChina() {
      if (!this.inputForm.tradingCountryId) return true
      const china = this.countryList.find(item => item.fullName === '中国')
      return china && String(this.inputForm.tradingCountryId) === String(china.id)
    },
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/base/itsBaseContractorInspect/queryById').then(({ data }) => {
        this.inputForm = data
        if(!data.attachIds) {
          this.inputForm.attachList = []
        }
        this.getDict([
          ['its_base_customer_category', 'contractorType'],
          ['its_base_contractor_category', 'contractorCategory']
        ])
      }).catch(e => {
        console.log(e)
      })
    },
    // 数据字典获取
    getDict(dicts) {
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({data}) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        }).catch(e => {
          console.log(e)
        })
      })
    },
    getDicts(dicts) {
      new QueryInfoService().getDictMap().then(({data}) => {
        // 遍历每个需要处理的字典类型和表单字段映射
        dicts.map(([dictType, formField]) => {
          // 1. 先获取当前表单字段的数组值
          const fieldValueArr = this.inputForm[formField];
          // 2. 校验值是否为有效数组，避免空值/非数组导致报错
          if (Array.isArray(fieldValueArr) && fieldValueArr.length > 0) {
            // 3. 遍历数组，把每个值映射为对应的标签（去掉可选链，手动判空）
            const labelArr = fieldValueArr.map(value => {
              // 先判断 data[dictType] 是否存在，再执行 find
              let dictItem = null;
              if (data[dictType]) {
                dictItem = data[dictType].find(item => item.value == value);
              }
              // 兜底：如果没找到对应字典项，返回原值或空字符串
              return dictItem ? dictItem.label : '';
            });
            // 拼接为字符串（如用逗号分隔）
            this.$set(this.inputForm, `${formField}Label`, labelArr.join(','));
          } else {
            // 空数组/非数组时，清空标签字段
            this.$set(this.inputForm, `${formField}Label`, []); // 或 ''（对应字符串拼接）
          }
        });
      }).catch(e => {
        console.error('获取字典失败：', e);
      });
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>

</style>